import { Directive, Input, OnInit, inject } from '@angular/core';
import { ClrDatagridHideableColumn } from '@clr/angular';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { TableViewOptionsService } from '../services/table-view-options.service';

@UntilDestroy()
@Directive({
	selector: '[svgFrontendsHideableColumn]',
	standalone: false,
})
export class TableViewColumnDirective implements OnInit {
	private host = inject(ClrDatagridHideableColumn, { host: true });
	private tableViewOptionsService = inject(TableViewOptionsService);

	@Input() svgFrontendsHideableColumn: string;
	@Input() svgFrontendsHideableColumnFilterName: string;

	ngOnInit(): void {
		this.tableViewOptionsService.setInitialHiddenStateFromStorage(
			this.svgFrontendsHideableColumn,
			this.host,
			this.svgFrontendsHideableColumnFilterName,
		);

		this.host.hiddenChange
			.asObservable()
			.pipe(untilDestroyed(this))
			.subscribe((hidden: boolean) =>
				this.tableViewOptionsService.changeColumnHiddenState({
					column: this.svgFrontendsHideableColumn,
					filterName: this.svgFrontendsHideableColumnFilterName,
					hidden,
				}),
			);
	}
}
